import { render, staticRenderFns } from "./AlertInformation.vue?vue&type=template&id=5d89ee59&lang=pug&"
import script from "./AlertInformation.vue?vue&type=script&lang=ts&"
export * from "./AlertInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports